import React, { useEffect, useState } from 'react';
import { Button, Form, Input, notification, Pagination, Popconfirm, Select, Spin, Table } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { ColumnsType } from 'antd/lib/table';

import {
  useDeleteBlockingMutation,
  useEmployeePasswordResetMutation,
  useLazyGetEmployeesLikeQuery,
  useRefresh1cMutation,
} from 'app/services/edpApiV1/employees';
import { useAppDispatch, useAppSelector } from 'app/store';
import { useDivisionsQuery, ViewerDivisionsResponse } from 'app/services/edpApiV1/viewer';

import { uiModel } from 'entities/ui';
import { viewerModel } from 'entities/viewer';

import { dataTableForEmployees } from 'shared/helpers/utils';
import { DataEmployees } from 'shared/types/types';

import { RolesUser } from 'shared/enums';
import { useScrollUpPage } from 'shared/hooks';
import { getAllAvailableOrganizations } from 'entities/organizations/model/organizations';
import style from './index.module.scss';
import BlockInfo from './blockInfo';

const { Search } = Input;

const initialValues = {
  selectOptions: 'search',
};

const EmployeesBlocked = () => {
  const [allDivisions, setAllDivisions] = useState<ViewerDivisionsResponse>();
  const [employees, setEmployees] = useState<DataEmployees[]>();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [currentSize, setCurrentSize] = useState<number>(10);
  const [totalPage, setTotalPage] = useState<number>(1);
  const [optionsSearch, setOptionsSearch] = useState<string>('search');
  const dispatch = useAppDispatch();
  const [form] = useForm();
  const allAvailableOrganizations = useAppSelector(getAllAvailableOrganizations);

  const { role } = useAppSelector(viewerModel.me.selectors.selectViewerProfile);
  const storeBlockedEmployees = useAppSelector(uiModel.BlockedEmployees.selectors.selectBlocked);
  const currentOrganizationid = useAppSelector(viewerModel.me.selectors.getMeOrganizationId);

  const [resetPasswordTrigger, passwordResetStatus] = useEmployeePasswordResetMutation();
  const [refresh1c, response] = useRefresh1cMutation();

  const [blockingTrigger, blockingResult] = useDeleteBlockingMutation();

  const { data: divisions } = useDivisionsQuery(null);

  const [getEmployees, result] = useLazyGetEmployeesLikeQuery();

  const optionsConfig = () => {
    if (storeBlockedEmployees?.divisionId && storeBlockedEmployees?.search) {
      return {
        divisionId: storeBlockedEmployees?.divisionId,
        search: storeBlockedEmployees?.search,
        isActive: false,
        page: currentPage,
        size: currentSize,
        allAvailableOrganizations,
        organizationId: currentOrganizationid,
      };
    }

    if (!storeBlockedEmployees?.divisionId && storeBlockedEmployees?.search) {
      return {
        search: storeBlockedEmployees.search,
        isActive: false,
        page: currentPage,
        size: currentSize,
        allAvailableOrganizations,
        organizationId: currentOrganizationid,
      };
    }

    if (storeBlockedEmployees?.divisionId && !storeBlockedEmployees?.search) {
      return {
        divisionId: storeBlockedEmployees?.divisionId,
        isActive: false,
        page: currentPage,
        size: currentSize,
        allAvailableOrganizations,
        organizationId: currentOrganizationid,
      };
    }

    return {
      isActive: false,
      page: currentPage,
      size: currentSize,
      allAvailableOrganizations,
      organizationId: currentOrganizationid,
    };
  };

  const {
    isSuccess: successPasswordReset,
    isError: errorPasswordReset,
    reset: resetPasswordStatus,
    data: dataMessage,
  } = passwordResetStatus;

  const { isSuccess: accessSuccess, isError: accessError, reset: resetAccess, data: dataAccess } = blockingResult;

  const resetPassword = (value: number) => {
    resetPasswordTrigger(value);
  };

  const searchWithOptions = () => {
    if (storeBlockedEmployees?.divisionId && storeBlockedEmployees?.search && !storeBlockedEmployees.personnelNumber) {
      getEmployees({
        divisionId: storeBlockedEmployees.divisionId,
        search: storeBlockedEmployees.search,
        isActive: false,
        page: currentPage,
        size: currentSize,
        allAvailableOrganizations,
        organizationId: currentOrganizationid,
      });
    }

    if (!storeBlockedEmployees?.divisionId && storeBlockedEmployees?.search && !storeBlockedEmployees.personnelNumber) {
      getEmployees({
        search: storeBlockedEmployees.search,
        isActive: false,
        page: currentPage,
        size: currentSize,
        allAvailableOrganizations,
        organizationId: currentOrganizationid,
      });
    }

    if (storeBlockedEmployees?.divisionId && !storeBlockedEmployees?.search && !storeBlockedEmployees.personnelNumber) {
      getEmployees({
        divisionId: storeBlockedEmployees.divisionId,
        isActive: false,
        page: currentPage,
        size: currentSize,
        allAvailableOrganizations,
        organizationId: currentOrganizationid,
      });
    }

    if (!storeBlockedEmployees?.divisionId && !storeBlockedEmployees?.search && storeBlockedEmployees.personnelNumber) {
      getEmployees({
        personnelNumber: storeBlockedEmployees.personnelNumber,
        isActive: false,
        page: currentPage,
        size: currentSize,
        allAvailableOrganizations,
        organizationId: currentOrganizationid,
      });
    }

    if (storeBlockedEmployees?.divisionId && !storeBlockedEmployees?.search && storeBlockedEmployees.personnelNumber) {
      getEmployees({
        divisionId: storeBlockedEmployees.divisionId,
        personnelNumber: storeBlockedEmployees.personnelNumber,
        isActive: false,
        page: currentPage,
        size: currentSize,
        allAvailableOrganizations,
        organizationId: currentOrganizationid,
      });
    }

    if (
      !storeBlockedEmployees?.divisionId &&
      !storeBlockedEmployees?.search &&
      !storeBlockedEmployees.personnelNumber
    ) {
      getEmployees({
        isActive: false,
        page: currentPage,
        size: currentSize,
        allAvailableOrganizations,
        organizationId: currentOrganizationid,
      });
    }
  };

  const onChangeBlocking = (value: number, blockingId: number) => {
    blockingTrigger({ employeeId: Number(value), blockingId });
  };

  const columns: ColumnsType<any> = [
    {
      title: 'id',
      dataIndex: 'key',
      key: 'key',
    },
    {
      title: 'Табельный номер',
      dataIndex: 'personnelNumber',
      key: 'personnelNumber',
    },
    {
      title: 'ФИО',
      dataIndex: 'fio',
      key: 'fio',
    },
    {
      title: 'Временный пароль',
      dataIndex: 'temporaryPassword',
      key: 'temporaryPassword',
    },
    {
      title: 'Действие',
      dataIndex: 'action',
      key: 'action',
      render: (_, record: any) => (
        <div
          className={style.controlsBtnGroup}
          onClick={e => {
            e.stopPropagation();
          }}
        >
          <Popconfirm placement="leftTop" title="Вы уверены?" onConfirm={() => resetPassword(Number(record.key))}>
            <Button danger>Сбросить пароль</Button>
          </Popconfirm>
          {role === RolesUser.HRDirector && (
            <Popconfirm
              placement="leftTop"
              title="Вы уверены?"
              onConfirm={async () => {
                try {
                  await refresh1c({ checkingNumber: record.personnelNumber }).unwrap();
                  notification.success({ message: 'Обновлено' });
                } catch {
                  notification.error({ message: 'Произошла ошибка' });
                }
              }}
            >
              <Button type="primary">Обновить в 1С</Button>
            </Popconfirm>
          )}
        </div>
      ),
    },
  ];

  const onSearch = (value: string) => {
    if (optionsSearch === 'search') {
      dispatch(uiModel.BlockedEmployees.actions.search(value));
      dispatch(uiModel.BlockedEmployees.actions.personnelNumber(''));
    } else {
      dispatch(uiModel.BlockedEmployees.actions.search(''));
      dispatch(uiModel.BlockedEmployees.actions.personnelNumber(value));
    }
  };

  const onClear = () => {
    dispatch(uiModel.BlockedEmployees.actions.divisionId(''));
    setCurrentPage(1);
  };

  const onSelectDivisionId = (id: string) => {
    dispatch(uiModel.BlockedEmployees.actions.divisionId(id));
    dispatch(uiModel.BlockedEmployees.actions.search(''));
    dispatch(uiModel.BlockedEmployees.actions.personnelNumber(''));
    setCurrentPage(1);
  };

  const handlePagination = (page: number, pageSize: number) => {
    setCurrentPage(page);
    setCurrentSize(pageSize);
  };

  const onSelectOptionsSearch = (value: string) => {
    setOptionsSearch(value);
  };

  useEffect(() => {
    getEmployees(optionsConfig());
    // чищу информацию о причине блокировки по пользователям при размонтировании компонента
    return () => {
      dispatch(uiModel.BlockedEmployees.actions.clearBlockInfo());
    };
  }, []);

  useEffect(() => {
    searchWithOptions();
  }, [
    storeBlockedEmployees?.divisionId,
    storeBlockedEmployees?.search,
    storeBlockedEmployees?.personnelNumber,
    currentPage,
    currentSize,
  ]);

  useEffect(() => {
    if (divisions) {
      setAllDivisions(divisions);
    }
  }, [divisions]);

  useEffect(() => {
    if (result?.data) {
      const dataSource = dataTableForEmployees(result?.data?.data);
      setEmployees(dataSource);
      setTotalPage(result.data.pagination.total);
    }
  }, [result?.data]);

  useEffect(() => {
    if (successPasswordReset) {
      notification.success({
        message: 'Пароль сброшен',
      });
    }
    resetPasswordStatus();
  }, [successPasswordReset]);

  useEffect(() => {
    if (errorPasswordReset) {
      notification.error({
        message: dataMessage,
      });
    }
    resetPasswordStatus();
  }, [errorPasswordReset, dataMessage]);

  useEffect(() => {
    if (accessSuccess) {
      notification.success({
        message: 'Пользователь разблокирован',
      });
    }
    resetAccess();
  }, [accessSuccess]);

  useEffect(() => {
    if (accessError) {
      notification.error({
        message: dataAccess,
      });
    }
    resetAccess();
  }, [accessError, dataAccess]);

  useEffect(
    () => () => {
      resetPasswordStatus();
      resetAccess();
    },
    [resetPasswordStatus, resetAccess],
  );

  useEffect(() => {
    if (storeBlockedEmployees?.divisionId !== '') {
      form.setFields([
        {
          name: 'divisionId',
          value: storeBlockedEmployees?.divisionId,
        },
      ]);
    } else {
      form.setFields([
        {
          name: 'divisionId',
          value: undefined,
        },
      ]);
    }

    if (storeBlockedEmployees?.search !== '') {
      form.setFields([
        {
          name: 'search',
          value: storeBlockedEmployees?.search,
        },
      ]);
    } else {
      form.setFields([
        {
          name: 'search',
          value: undefined,
        },
      ]);
    }

    if (storeBlockedEmployees?.personnelNumber !== '') {
      form.setFields([
        {
          name: 'personnelNumber',
          value: storeBlockedEmployees?.personnelNumber,
        },
      ]);
    } else {
      form.setFields([
        {
          name: 'personnelNumber',
          value: undefined,
        },
      ]);
    }
  }, [storeBlockedEmployees?.divisionId, storeBlockedEmployees?.search, storeBlockedEmployees?.personnelNumber]);

  useEffect(() => {
    dispatch(uiModel.BlockedEmployees.actions.divisionId(''));
    dispatch(uiModel.BlockedEmployees.actions.search(''));
    dispatch(uiModel.BlockedEmployees.actions.personnelNumber(''));
  }, [dispatch, allDivisions]);

  useScrollUpPage(currentPage);
  // сбрасываю значение фильтра при смене организации
  useEffect(() => {
    form.setFields([
      {
        name: 'selectOptions',
        value: 'search',
      },
    ]);
    setOptionsSearch('search');
    setCurrentPage(1);
  }, [currentOrganizationid]);
  return (
    <>
      <Form form={form} className={style.searchWrap} initialValues={initialValues}>
        {allDivisions && (
          <Form.Item name="divisionId">
            <Select
              placeholder="Выберите из списка"
              className={style.selectDivisions}
              onSelect={onSelectDivisionId}
              allowClear={true}
              onClear={onClear}
            >
              {allDivisions.data?.map(({ id, name }) => (
                <Select.Option key={id} value={id}>
                  {name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        )}

        <Form.Item name="selectOptions">
          <Select placeholder="Параметры поиска" className={style.selectDivisions} onSelect={onSelectOptionsSearch}>
            <Select.Option key="search" value="search">
              Поиск по ФИО
            </Select.Option>
            <Select.Option key="personnelNumber" value="personnelNumber">
              Поиск по табельному №
            </Select.Option>
          </Select>
        </Form.Item>

        {optionsSearch === 'search' ? (
          <Form.Item name="search" className={style.searchInput}>
            <Search placeholder="Поиск сотрудника по ФИО" allowClear onSearch={onSearch} />
          </Form.Item>
        ) : (
          <Form.Item
            name="personnelNumber"
            className={style.searchInput}
            normalize={value => value.replace(/[^0-9]/g, '')}
          >
            <Search placeholder="Поиск сотрудника по табельному №" allowClear onSearch={onSearch} />
          </Form.Item>
        )}
      </Form>
      <Spin spinning={result?.isLoading || result?.isFetching}>
        <div className={style.tableWrap}>
          <Table
            scroll={{ x: true }}
            dataSource={employees}
            columns={columns}
            pagination={false}
            expandable={{
              expandedRowRender: (record: { key: React.Key }) => (
                <BlockInfo userId={record.key as number} onChangeBlocking={onChangeBlocking} />
              ),
              showExpandColumn: role === RolesUser.HRDirector,
            }}
          />
          <div className={style.paginationWrap}>
            <Pagination
              showSizeChanger
              defaultCurrent={currentSize}
              current={currentPage}
              pageSize={currentSize}
              total={totalPage}
              onChange={(value: number, pageSize: number) => handlePagination(value, pageSize)}
            />
          </div>
        </div>
      </Spin>
    </>
  );
};

export default EmployeesBlocked;
